import React from 'react'
import { observer } from 'mobx-react'
import { useValue } from '@morningtrain/react-resources'
import moment from 'moment'

function DateRange ({ defaultValue = { from: null, to: null } }) {
  const from = useValue('from', defaultValue.from)
  const to = useValue('to', defaultValue.to)

  if (!from && !to) {
    return null
  }

  const parsedFrom = moment(from)
  const parsedTo = moment(to)

  if (from === to) {
    return parsedFrom.format('ddd DD. MMM YYYY')
  } else {
    if (parsedFrom.isSame(parsedTo, 'year')) {
      if (parsedFrom.isSame(parsedTo, 'month')) {
        return parsedFrom.format('ddd DD.') + ' - ' + parsedTo.format('ddd DD. MMM YYYY')
      } else {
        return parsedFrom.format('ddd DD. MMM') + ' - ' + parsedTo.format('ddd DD. MMM YYYY')
      }
    } else {
      return parsedFrom.format('ddd DD. MMM YYYY') + ' - ' + parsedTo.format('ddd DD. MMM YYYY')
    }
  }

  return null
}

export default observer(DateRange)
